import { render, staticRenderFns } from "./location_submit.vue?vue&type=template&id=10812f87&"
import script from "./location_submit.vue?vue&type=script&lang=js&"
export * from "./location_submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports